import { AlertCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

import ModernPageLayout from "@/components/layout/ModernPageLayout";
import EmptyState from "@/components/ui/v2/empty-state";

type SegmentLoadErrorProps = {
  onRetry: () => void;
};

export function SegmentLoadError({ onRetry }: SegmentLoadErrorProps) {
  const { t } = useTranslation();

  return (
    <ModernPageLayout>
      <EmptyState
        icon={AlertCircle}
        title={t("admin.segments.builder.loadError.title")}
        description={t("admin.segments.builder.loadError.description")}
        action={{ label: t("common.retry"), onClick: onRetry }}
      />
    </ModernPageLayout>
  );
}
